export const splitArrayIntoRows = (numberOfRows: number, items: Array<string>) => {
	if (numberOfRows <= 0) {
		return []
	}

	const result = []
	const partSize = Math.ceil(items.length / numberOfRows)

	for (let i = 0; i < items.length; i += partSize) {
		result.push(items.slice(i, i + partSize))
	}
	return result
}
